import { SuspensePageBoundary } from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { BrowseWordsSkeleton } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._components.loading-skeletons";
import { PrimaryControlsStripTitle } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.title";
import { BrowseWordsPrimaryControlsStripExpansionContent } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.words._components.primary-controls-strip-expansion-content";
import { BrowseWordsPageContent } from "#browse-words-page-content";
import { PrimaryControlsStripBack } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.back";
import { LazyBrowseTabContent } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._lib.focus";
import {
  BrowseWordsPageContextBridge,
  BrowseWordsPageContextProvider,
} from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.words._context";

export function BrowseWordsPage() {
  return (
    <BrowseWordsPageContextProvider>
      <PrimaryControlsStripBack hidden />
      <LazyBrowseTabContent>
        <BrowseWordsPageContextBridge>
          <BrowseWordsPrimaryControlsStripExpansionContent />
        </BrowseWordsPageContextBridge>
      </LazyBrowseTabContent>
      <PrimaryControlsStripTitle>Words</PrimaryControlsStripTitle>
      <SuspensePageBoundary fallback={<BrowseWordsSkeleton />} location={import.meta.location}>
        <BrowseWordsPageContent />
      </SuspensePageBoundary>
    </BrowseWordsPageContextProvider>
  );
}
